var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-footer',{class:_vm.adaptiveClass,staticStyle:{"margin-top":"126px","z-index":"2"},attrs:{"height":_vm.height,"color":"primary","padless":""}},[(!_vm.isMobile)?_c('FooterDesktop',{attrs:{"contents":_vm.contents}}):_c('FooterMobile',{attrs:{"contents":_vm.contents}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }